import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    FETCH_FOURNISSEURS_REQUEST,
    fetchFournisseursSuccess,
    fetchFournisseursFail,
    createFournisseurSuccess,
    createFournisseurFail,
    updateFournisseurSuccess,
    updateFournisseurFail,
    deleteFournisseurSuccess,
    deleteFournisseurFail,
    setFournisseursLoading,
} from "../actions/fournisseursActions";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchFournisseursSaga() {
    const url = `${API_BASE_URL}/api/fournisseurs`;
    yield put(setFournisseursLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(fetchFournisseursSuccess(resp.data));
    } catch (e) {
        yield put(fetchFournisseursFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setFournisseursLoading(false));
    }
}

export function* createFournisseurSaga(action) {
    const url = `${API_BASE_URL}/api/fournisseurs`;
    yield put(setFournisseursLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid: getUid(), token: getToken() });
        yield put(createFournisseurSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Fournisseur ajouté", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_FOURNISSEURS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout fournisseur";
        yield put(createFournisseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setFournisseursLoading(false));
    }
}

export function* updateFournisseurSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/fournisseurs/${id}`;
    yield put(setFournisseursLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid: getUid(), token: getToken() });
        yield put(updateFournisseurSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Fournisseur modifié", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_FOURNISSEURS_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification fournisseur";
        yield put(updateFournisseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setFournisseursLoading(false));
    }
}

export function* deleteFournisseurSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/fournisseurs/${id}`;
    yield put(setFournisseursLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteFournisseurSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Fournisseur supprimé", timer: 1400, showConfirmButton: false });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression fournisseur";
        yield put(deleteFournisseurFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setFournisseursLoading(false));
    }
}
